import { isAfter, subDays } from 'date-fns';

import { DisplayDossierOverview } from '../resources/dossier/types';

import { Priority } from '../resources/todo/types';

import { NEW_REQUEST_STEP, TRAVELLING_STEP } from './step';

function paymentDeadlineExpired(
    { project: { expectedArrivalDate } }: DisplayDossierOverview,
    currentDate: number,
): boolean | null | undefined {
    return expectedArrivalDate && isAfter(currentDate, subDays(expectedArrivalDate, 41));
}

export const highPriorityRules: (
    currentDate: number,
) => ((dossier: DisplayDossierOverview) => boolean | null | undefined)[] = (
    currentDate: number,
) => [
    (dossier: DisplayDossierOverview) => dossier.task.actionType === 'call',
    (dossier: DisplayDossierOverview) => dossier.task.actionType === 'make_a_quote',
    (dossier: DisplayDossierOverview) =>
        dossier.task.actionType === 'ask_for_payment' &&
        paymentDeadlineExpired(dossier, currentDate),
    (dossier: DisplayDossierOverview) =>
        dossier.step === NEW_REQUEST_STEP &&
        dossier.rating >= 3 &&
        dossier.task.definition === 'new_request.contact',
    (dossier: DisplayDossierOverview) =>
        dossier.step === TRAVELLING_STEP &&
        dossier.discussion.lastTravellerToAgentMessageDate &&
        dossier.discussion.lastAgentToTravellerMessageDate &&
        isAfter(
            dossier.discussion.lastTravellerToAgentMessageDate,
            dossier.discussion.lastAgentToTravellerMessageDate,
        ),
];
export const mediumPriorityRules: (
    currentDate: number,
) => ((dossier: DisplayDossierOverview) => boolean)[] = (currentDate: number) => [
    (dossier: DisplayDossierOverview) => dossier.task.actionType === 'follow_up',
    (dossier: DisplayDossierOverview) =>
        dossier.task.actionType === 'ask_for_payment' &&
        !paymentDeadlineExpired(dossier, currentDate),
    (dossier: DisplayDossierOverview) => dossier.step === NEW_REQUEST_STEP && dossier.rating < 3,
];
export const priorities: Priority[] = ['high', 'medium', 'low'];
